(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(() => {

  if (!customElements.get('nius-free-shipping-progress')) {
    let previousProgress = 0;
    customElements.define('nius-free-shipping-progress', class extends HTMLElement {
      connectedCallback() {
        const progress = Math.max(0, Math.min(100, Number(this.dataset.progress) || 0)) / 100;
        const fill = this.querySelector('.nius-shipping-progress__fill');
        if (fill && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          fill.animate([
            { transform: 'scaleX(' + previousProgress + ')' },
            { transform: 'scaleX(' + progress + ')' }
          ], { duration: 450, easing: 'ease-out' });
        }
        previousProgress = progress;
      }
    });
  }

  if (customElements.get('nius-delivery-estimate')) return;

  const berlinClock = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit',
    day: '2-digit', hour: '2-digit', hourCycle: 'h23'
  });
  const dateLabel = new Intl.DateTimeFormat('de-DE', {
    timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'numeric'
  });

  function estimate(now) {
    const parts = Object.fromEntries(
      berlinClock.formatToParts(now).map(part => [part.type, part.value])
    );
    const shipping = new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day));
    const weekday = shipping.getUTCDay();
    if (weekday === 0 || weekday === 6 || +parts.hour >= 14) {
      shipping.setUTCDate(shipping.getUTCDate() + 1);
      while (shipping.getUTCDay() === 0 || shipping.getUTCDay() === 6) {
        shipping.setUTCDate(shipping.getUTCDate() + 1);
      }
    }
    const first = new Date(shipping);
    do { first.setUTCDate(first.getUTCDate() + 1); }
    while (first.getUTCDay() === 0);
    const last = new Date(first);
    do { last.setUTCDate(last.getUTCDate() + 1); }
    while (last.getUTCDay() === 0);
    return { shipping, first, last };
  }

  class NiusDeliveryEstimate extends HTMLElement {
    connectedCallback() {
      this.refresh = () => {
        clearTimeout(this.timer);
        const dates = estimate(new Date());
        this.textContent = 'ca. ' + dateLabel.format(dates.first) + ' – ' + dateLabel.format(dates.last);
        this.title = 'Voraussichtlicher Versand: ' + dateLabel.format(dates.shipping) + '. Feiertage sind nicht berücksichtigt.';
        this.timer = setTimeout(this.refresh, 60000 - Date.now() % 60000 + 50);
      };
      this.refresh();
    }
    disconnectedCallback() { clearTimeout(this.timer); }
  }
  customElements.define('nius-delivery-estimate', NiusDeliveryEstimate);
})();

  } catch(e) { console.error(e); }
})();
})();
